export default "__VITE_ASSET__JpzySOgY__"